import { render, staticRenderFns } from "./YesNo.vue?vue&type=template&id=28579b06&scoped=true&"
import script from "./YesNo.vue?vue&type=script&lang=js&"
export * from "./YesNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28579b06",
  null
  
)

export default component.exports